import { useBunkerContext } from 'src/context/BunkerContext';
import { mapBunkeringBMs, mapFuelRobBMs, mapBunkerLossBMs } from 'src/factory/Bunkering/BunkeringFactory';
import { BunkeringBM } from 'src/types/BusinessModel/Bunkering/BunkeringBM';
import { FuelRobBM } from 'src/types/BusinessModel/Bunkering/FuelRobBM';
import { BunkerLossBM } from 'src/types/BusinessModel/Bunkering/BunkerLossBM';
import { getAllBunkeringItems, getAllBunkeringStatusItems, getAllFuelRobItems } from 'src/api/bunkering/offlineBunkeringApi';
import { markAuthoritativeFuelRobApplied, markAuthoritativeBunkerLossApplied } from 'src/api/bunkering/bunkeringDataGuard';

// Handles fresh data pushed back from the service worker's `refresh_containing` flow
// (see useSWService.refreshRequestsContaining / handleRefreshUrl) for the Bunkering GET
// endpoints. Without this, the authoritative post-sync data fetched after
// useSyncOfflineBunkering.syncBunkerings() completes was silently discarded, so the ROB
// tab only ever showed correct data again after a manual page refresh (Phase 10 fix).
export const useBunkerRefreshResponseHandler = () => {
    const { bunkeringEvents, setBunkerings, setDeletedBunkerings, setFuelRobData, setBunkerLossData } = useBunkerContext();

    const onGetBunkerings = async (bms: BunkeringBM[]) => {
        const offlineBunkerings = await getAllBunkeringItems();
        const offlineBunkeringStatuses = await getAllBunkeringStatusItems();
        const _bunkerings = mapBunkeringBMs(bms, bunkeringEvents, offlineBunkerings, offlineBunkeringStatuses);
        setBunkerings(_bunkerings.bunkerings);
        setDeletedBunkerings(_bunkerings.deletedBunkerings);
    };

    const onGetFuelRobData = async (bms: FuelRobBM[]) => {
        const offlineFuelRobs = await getAllFuelRobItems();
        const _fuelRobData = mapFuelRobBMs(bms, offlineFuelRobs);
        setFuelRobData(_fuelRobData);
        markAuthoritativeFuelRobApplied();
    };

    const onGetBunkerLossData = (bms: BunkerLossBM[]) => {
        const _bunkerLossData = mapBunkerLossBMs(bms);
        setBunkerLossData(_bunkerLossData);
        markAuthoritativeBunkerLossApplied();
    };

    return {
        onGetBunkerings,
        onGetFuelRobData,
        onGetBunkerLossData,
    };
};
